(function() {
  window.toggleExchangeContent = function toggleExchangeContent(target) {
    const currentContent = target.closest('.productExchangeOnly');

    currentContent.classList.toggle('productExchangeOnly--active');
  }

  window.closeExchangeContent = function closeExchangeContent(target) {
    const activeContent = document.querySelectorAll('.productExchangeOnly--active');

    activeContent.forEach((content) => {
      content.classList.remove('productExchangeOnly--active');
    });
  }

  window.initToggleExchangeContent = function initToggleExchangeContent() {
    const exchangeOnlyTitles = document.querySelectorAll('.productExchangeOnly__title');

    if (window.innerWidth <= 768) {
      exchangeOnlyTitles.forEach((title) => {
        title.addEventListener('click', (e) => {
          e.stopPropagation();
          window.toggleExchangeContent(e.currentTarget);
        });
      });
    }
  }

  window.initToggleExchangeProduct = function initToggleExchangeProduct() {
    const exchangeOnlyTitles = document.querySelectorAll('.productPopUp__productWrapper .productExchangeOnly__title');

    if (window.innerWidth <= 768) {
      exchangeOnlyTitles.forEach((title) => {
        title.addEventListener('click', (e) => {
          e.stopPropagation();
          window.toggleExchangeContent(e.currentTarget);
        });
      });
    }
  }

  window.initToggleExchangeContent();
  window.initToggleExchangeProduct();

  window.addEventListener('click', (e) => {
    closeExchangeContent(e.currentTarget);
  });
})();
